import type {ListClientsSearchInput} from "./list-clients.schema";

import {listClients} from "@project/sdk/sales";
import {ListClientsResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {clientKeys} from "../../../client-keys";

import {listClientsSearchSchema} from "./list-clients.schema";

export function listClientsQueryOptions(rawInput: ListClientsSearchInput) {
  const params = listClientsSearchSchema.parse(rawInput);

  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryFn: async ({signal}) => ListClientsResponse.parse(await listClients(params, {signal})),
    queryKey: clientKeys.list(params),
  });
}
